(() => {
  if (window.arbWishlist) return;

  const KEY = 'arb-wishlist';

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable: the heart still toggles for this page view */
    }
    document.dispatchEvent(new CustomEvent('arb:wishlist', { detail: list }));
  };

  window.arbWishlist = {
    list: read,
    has: (handle) => read().includes(handle),
    toggle(handle) {
      const list = read();
      const i = list.indexOf(handle);
      if (i === -1) list.unshift(handle);
      else list.splice(i, 1);
      write(list);
      return i === -1;
    },
    remove(handle) {
      write(read().filter((h) => h !== handle));
    },
  };

  const syncCount = () => {
    const n = read().length;
    document.querySelectorAll('[data-arb-wishlist-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  };

  customElements.define(
    'arb-wishlist-button',
    class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('button');
        this.text = this.querySelector('.arb-wish__text');
        this.onChange = () => this.render();
        this.btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const added = window.arbWishlist.toggle(this.dataset.handle);
          if (added) {
            this.classList.remove('is-popping');
            void this.offsetWidth;
            this.classList.add('is-popping');
          }
        });
        document.addEventListener('arb:wishlist', this.onChange);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('arb:wishlist', this.onChange);
      }

      render() {
        const on = window.arbWishlist.has(this.dataset.handle);
        const label = on ? this.dataset.labelRemove : this.dataset.labelAdd;
        this.classList.toggle('is-active', on);
        this.btn.setAttribute('aria-pressed', on);
        this.btn.setAttribute('aria-label', label);
        if (this.text) this.text.textContent = label;
      }
    }
  );

  document.addEventListener('arb:wishlist', syncCount);
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) document.dispatchEvent(new CustomEvent('arb:wishlist', { detail: read() }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCount);
  else syncCount();
})();
